import React, { useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import { CloseOutlined, MailOutlined } from "@ant-design/icons";
import {
  ActivitySection,
  ActvtySecTitle,
  ActvtySecWrapper,
  Container,
  InfoSection,
  InfoSectionImg,
  Title,
  TitleHead,
  TitleInfo,
  AlertMessageContainer,
  AlertMessage,
  AlertMessageContent,
  IconContainer,
  InfoSectionFig,
} from "../../Styles";
import image from "../../assets/images/ForgPass.svg";
import "../../Styles.css";
import fire from "../../fire";

function ForgotPassword() {
  const [errorMessage, seterrorMessage] = useState("");

  const onFinish = (values: any) => {
    fire
      .auth()
      .sendPasswordResetEmail(values.email)
      .then(() => {
        // Password reset email sent!
        // ..
        function countDown() {
          let secondsToGo = 2;
          const modal = Modal.success({
            title: `Reset Password Link Sent To ${values.email}`,
          });
          const timer = setInterval(() => {
            secondsToGo -= 1;
          }, 1000);
          setTimeout(() => {
            clearInterval(timer);
            modal.destroy();
          }, secondsToGo * 1000);
        }
        countDown();
      })
      .catch((error) => {
        // var errorCode = error.code;
        // var errorMessage = error.message;
        // console.log(error.code, error.message);
        if (error.code == "auth/user-not-found") {
          seterrorMessage("Please Enter Correct Email ID");
        } else {
          seterrorMessage(error.message);
        }
      });
  };

  return (
    <Container>
      <InfoSection>
        <InfoSectionFig>
          {" "}
          <InfoSectionImg src={image} />
        </InfoSectionFig>

        <Title>
          <TitleHead>Some title goes here</TitleHead>
          <TitleInfo>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.
          </TitleInfo>
        </Title>
      </InfoSection>
      <ActivitySection>
        <ActvtySecWrapper>
          <ActvtySecTitle>Forgot Password</ActvtySecTitle>
          {errorMessage && (
            <AlertMessageContainer style={{ top: "1%" }}>
              <AlertMessage style={{ height: "12px" }}>
                <AlertMessageContent style={{ top: "3px" }}>
                  {" "}
                  {errorMessage}
                </AlertMessageContent>
                <IconContainer style={{ top: "4px" }}>
                  <CloseOutlined onClick={() => seterrorMessage("")} />
                </IconContainer>
              </AlertMessage>
            </AlertMessageContainer>
          )}
          <Form
            name="basic"
            initialValues={{}}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Email ID!",
                },
                {
                  type: "email",
                  message: "This is not valid E-mail!",
                },
                {
                  pattern: /[@]/g,
                  message: "An Email Address Must Contain a Single @!",
                },
              ]}
            >
              <Input
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="Email"
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="loginButton">
                Send
              </Button>
            </Form.Item>
          </Form>
        </ActvtySecWrapper>
      </ActivitySection>
    </Container>
  );
}

export default ForgotPassword;
